import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { apiParameters } from 'src/app/configs/api.params';
import { IFilial } from '../models/filial.model';

@Injectable({
  providedIn: 'root',
})
export class FilialService {
  public apiEndPoint = apiParameters.url;

  constructor(private http: HttpClient) {}

  getCompanyFilials(companyId: string, name:string): Observable<IFilial[]> {
    let searchParams = new HttpParams();

    if (name && name !== '') {
      searchParams = searchParams.append('name', name);
    }

    const httpOptions = {
      params: searchParams,
    };

    return this.http.get<IFilial[]>(
      `${apiParameters.url}/companies/${companyId}/filials`, httpOptions
    );
  }

  getFilialById(companyId: string, filialId: string): Observable<IFilial> {
    return this.http.get<IFilial>(
      `${apiParameters.url}/companies/${companyId}/filials/${filialId}`
    );
  }

  createFilial(companyId: string, body): Observable<IFilial> {
    return this.http.post<IFilial>(
      `${apiParameters.url}/companies/${companyId}/filials`,
      body
    );
  }

  editFilial(companyId: string, filialId: string, body): Observable<IFilial> {
    return this.http.patch<IFilial>(
      `${apiParameters.url}/companies/${companyId}/filials/${filialId}`,
      body
    );
  }

  deleteFilial(companyId: string, filialId: string): Observable<any> {
    return this.http.delete(
      `${apiParameters.url}/companies/${companyId}/filials/${filialId}`
    );
  }

  getAllDeletedFilialsByCompany(companyId: string, date: string) {
    return this.http.get(
      `${apiParameters.url}/companies/${companyId}/deleted-filials/${date}`
    );
  }

  createFilialAdmin(companyId: string, body: any): Observable<IFilial> {
    return this.http.post<IFilial>(
      `${apiParameters.url}/companies/${companyId}/filial-admins`,
      body
    );
  }


  getAllFilials( page?: number, limit?: number,companyId?: string, name?:string): Observable<any> {
    let searchParams = new HttpParams();

    if (companyId && companyId !== '') {
      searchParams = searchParams.append('companyId', companyId);
    }
    if (name && name !== '') {
      searchParams = searchParams.append('name', name);
    }

    const httpOptions = {
      params: searchParams,
      headers: new HttpHeaders({
        page: page.toString(),
        limit: limit.toString(),
      }),
    };

    return this.http.get<any>(
      `${apiParameters.url}/filials`, httpOptions
    );
  }


}
